import colors from '../../../../../public/colors'


export default theme => {
    const { mode } = theme.palette
    return {
        completed: {
            color: colors[mode].cardImageTextRBCHover,
            height: '22px',
            justifyContent: 'center',
            minHeight: '20px',
            minWidth: '20px',
            textAlign: 'center',
            width: '22px',
        },
        frenchLayout: {
            
            
            [theme.breakpoints.down('md')]: {
                paddingLeft: '5% !important',
                paddingRight: '0 !important',
                width: '100%'
            },
            [theme.breakpoints.down('sm')]: {
                paddingLeft: '2% !important',
                paddingRight: '6% !important',
                width: '89% !important'
            }
        },
        linearBar: {
            backgroundColor: colors[mode].linearProgress,
            boxSizing: 'border-box',
            flexShrink: 1,
            height: '2.2px',
            minWidth: '20px',
            width: '100px',
            [theme.breakpoints.down('md')]: {
                width: '80px'
            },
            [theme.breakpoints.down('sm')]: {
                width: '50px'
            },
            [theme.breakpoints.down('xs')]: {
                width: '30px'
            }
        },
        registrationBarContainer: {
            alignItems: 'center',
            backgroundColor: colors[mode].secondaryBackground,
            boxSizing: 'border-box',
            display: 'grid',
            gap: '0',
            gridTemplateColumns: 'auto auto auto',
            height: 'auto',
            justifyContent: 'center',
            padding: '2% 0% 0% 0%',
            width: '100%',
            [theme.breakpoints.down('sm')]: {
                paddingLeft: '2%',
                paddingRight: '4%',
                width: '89%'
            }
        },
        stepFirst:{
            gridTemplateColumns: 'auto auto auto',
        },
        stepNumber: {
            alignItems: 'center',
            backgroundColor: colors[mode].cardImageTextRBCHover,
            borderRadius: '50%',
            color: colors[mode].passwordUpdatebannerText,
            display: 'flex',
            flexShrink: 0,
            fontSize: '0.85rem',
            height: '22px',
            justifyContent: 'center',
            minHeight: '20px',
            minWidth: '20px',
            textAlign: 'center',
            width: '22px',
            [theme.breakpoints.down('md')]: {
                fontSize: '0.75rem',
                height: '20px',
                minHeight: '18px',
                minWidth: '18px',
                width: '20px'
            },
            [theme.breakpoints.down('sm')]: {
                fontSize: '0.7rem',
                height: '18px',
                minHeight: '16px',
                minWidth: '16px',
                width: '18px'
            }
        },
        stepNumberDisabled: {
            backgroundColor: colors[mode].cardDescription,
        },
        stepPaper: {
            alignItems: 'center',
            background: colors[mode].secondaryBackground,
            boxShadow: 'none',
            boxSizing: 'border-box',
            display: 'grid',
            flexShrink: 1,
            gap: '7px',
            gridTemplateColumns: 'auto auto auto',
            padding: '8px 4px',
            [theme.breakpoints.down('md')]: {
                gap: '10px',
                gridTemplateColumns: 'auto auto auto',
                padding: '8px 2px'
            },
            [theme.breakpoints.down('sm')]: {
                gap: '6px',
                gridTemplateColumns: 'auto minmax(0, 1fr) auto',
                padding: '4px 2px'
            }
        },
        stepPaperThird: {
            alignItems: 'center',
            backgroundColor: colors[mode].secondaryBackground,
            boxShadow: 'none',
            boxSizing: 'border-box',
            display: 'grid',
            flexShrink: 1,
            gap: '8px',
            gridTemplateColumns: 'auto 1fr',
            padding: '8px 4px',
            [theme.breakpoints.down('md')]: {
                gap: '7px',
                padding: '8px 2px'
            },
            [theme.breakpoints.down('sm')]: {
                gap: '6px',
                gridTemplateColumns: 'auto minmax(0, 1fr)',
                padding: '4px 2px'
            }
        },
        stepText: {
            color: colors[mode].mfaActiveBackground,
            fontSize: '0.85rem',
            fontWeight: 500,
            minWidth: 0,
            overflow: 'visible',
            textOverflow: 'clip',
            whiteSpace: 'pre-line',
            [theme.breakpoints.down('sm')]: {
                fontSize: '0.75rem'
            }
        }
    }
}